import { rosterURL } from 'endpoints';
import fetch from '../utils/fetch';
import { tokenServiceUrl } from '../endpoints.js';

export const getPeople = async ( companyId ) => {
    const body = {
        pageSize: 500
    };
    try {
        const res = await fetch( `${ rosterURL }/search`, {
            method: 'POST',
            headers: { 
                'content-type': 'application/json',
                'company-id': companyId
            },
            body: JSON.stringify( body )
        } );
        const data = await res.json();
        return data.persons;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const searchPeople = async ( searchText, companyId, searchFields = [ 'firstName', 'lastName' ] ) => {
    try {
        const res = await fetch( `${ rosterURL }/search`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'company-id': companyId,
                'authorization': `Bearer ${ localStorage.getItem( 'companyAccessToken' ) }`
            },
            body: JSON.stringify( {
                genericSearch: {
                    searchFields,
                    searchText
                },
                pageSize: 10
            } )
        } );

        const data = await res.json();

        return data.persons;
    } catch ( error ) {
        throw new Error( error );
    }
};

export async function getAccessTokenForCompany ( accessToken, companyId ) {
    const payload = JSON.parse( atob( accessToken.split( '.' )[ 1 ] ) );

    const base64Encode = ( str ) => {
        return btoa( encodeURIComponent( str ).replace(
            /%([0-9A-F]{2})/g,
            ( match, p1 ) => String.fromCharCode( '0x' + p1 )
        ) );
    };

    const subjectHeader = base64Encode( JSON.stringify( {
        alg: 'none'
    } ) );
    const subjectPayload = base64Encode( JSON.stringify( {
        aud: payload.aud,
        cmp: companyId,
        sub: payload.sub,
        may_act: {
            aud: payload.aud,
            cmp: payload.cmp,
            sub: payload.sub
        }
    } ) );

    const subjectToken = `${ subjectHeader }.${ subjectPayload }.`;

    const response = await fetch( tokenServiceUrl, {
        method: 'POST',
        headers: {
            'content-type': 'application/x-www-form-urlencoded'
        },
        body: [
            `grant_type=${ encodeURIComponent( 'urn:ietf:params:oauth:grant-type:token-exchange' ) }`,
            `&subject_token=${ subjectToken }`,
            `&subject_token_type=${ encodeURIComponent( 'urn:ietf:params:oauth:token-type:jwt' ) }`,
            `&actor_token=${ accessToken }`,
            `&actor_token_type=${ encodeURIComponent( 'urn:ietf:params:oauth:token-type:access_token' ) }`,
            `&client_id=${ encodeURIComponent( payload.aud ) }`
        ].join( '' ),
        noBearer: true
    } );

    const data = await response.json();

    if ( response.ok ) {
        return data.access_token;
    } else {
        throw data;
    }
}